/**
 * react-hot-toast knows no "warning" type: a toast with this className is drawn as a warning
 * (see Toaster).
 */
export const WARNING_TOAST_CLASS = "warning"
